import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw, X } from 'lucide-react';
import { Button } from './Button';

export const PwaUpdater: React.FC = () => {
    const {
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r: ServiceWorkerRegistration | undefined) {
            if (r) {
                // Check for updates every hour
                setInterval(() => {
                    r.update().catch(() => { /* empty */ });
                }, 60 * 60 * 1000);
                
                // Check for updates when user comes back to the app
                document.addEventListener('visibilitychange', () => {
                    if (document.visibilityState === 'visible') {
                        r.update().catch(() => { /* empty */ });
                    }
                });
            }
        },
        onRegisterError(error: unknown) {
            console.log('SW registration error', error);
        },
    });

    if (!needRefresh) return null;

    return (
        <div className="fixed bottom-20 left-4 right-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-300">
            <div className="bg-primary-600 text-white p-4 rounded-xl shadow-lg flex items-center justify-between gap-4 border border-primary-700">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-white/20 rounded-lg shrink-0">
                        <RefreshCw size={20} className="animate-spin" />
                    </div>
                    <div>
                        <p className="font-bold text-sm">App Update Available</p>
                        <p className="text-xs text-primary-100">A new version of Evenly is ready.</p>
                    </div>
                </div>
                <div className="flex gap-2 shrink-0">
                    <Button 
                        size="sm" 
                        className="bg-white text-primary-700 hover:bg-slate-100 border-none"
                        onClick={() => updateServiceWorker(true)}
                    >
                        Update Now
                    </Button>
                    <button 
                        onClick={() => { setNeedRefresh(false); }}
                        className="p-2 hover:bg-white/10 rounded-lg transition-colors"
                    >
                        <X size={16} />
                    </button>
                </div>
            </div>
        </div>
    );
};
